module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "backTop",
    on: {
      "click": _vm.btnBackTop
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/assets/btn-icon-top.png"),
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34c581c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/BackTop.vue
// module id = 1481
// module chunks = 1